// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3cFNM","choiceBoxes":"toolbarselects_choiceBoxes__2XCGB","simpleField":"toolbarselects_simpleField__2Hk3g"};